export default "__VITE_ASSET__BvZZK2pK__"